import PropTypes from "prop-types";
import { LeaveAndDeleteSpaceOptions } from "./LeaveAndDeleteSpaceOptions";
import { ManageSpaceOptions } from "./ManageSpaceOptions";

export const CourseSpaceOptions = ({
  space,
  isAdmin,
  canMemberManageSpace,
  onInviteMember,
}) => (
  <>
    {/* TODO: To be implemented with Courses */}
    {/* {isMember && (
        <div className="md:hidden"></div>
      )} */}
    {canMemberManageSpace && (
      <ManageSpaceOptions space={space} onInviteMember={onInviteMember} />
    )}
    <LeaveAndDeleteSpaceOptions space={space} isAdmin={isAdmin} />
  </>
);

CourseSpaceOptions.propTypes = {
  space: PropTypes.object.isRequired,
  isAdmin: PropTypes.bool,
  canMemberManageSpace: PropTypes.bool,
  onInviteMember: PropTypes.func,
};
